import { useI18nContext } from "@i18n/i18n-react";
import { T } from "@i18n/T";
import { Button } from "@shadcn/ui/button";
import { createFileRoute, Link } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { CheckCircle } from "lucide-react";
import z from "zod";
import { AppHeader } from "~/components/layout/AppHeader";
import { PageContainer } from "~/components/layout/PageContainer";

export const Route = createFileRoute("/one-delivery/finish")({
	beforeLoad: () => {
		document.title = "bacehub | One Delivery";
	},
	component: RouteComponent,
	validateSearch: zodValidator(z.object({ bundleId: z.string() })),
});

function RouteComponent() {
	const i18n = useI18nContext().LL["new-ui"];
	const { bundleId } = Route.useSearch();
	return (
		<PageContainer>
			<AppHeader showHelpButton={true} />
			<main className="flex flex-col items-center gap-4 px-6 py-12 text-center">
				<CheckCircle className="size-16 text-green-600" />
				<h1 className="text-2xl font-breit">
					<T>{i18n.OD_PICKED_UP_TITLE()}</T>
				</h1>
				<p className="text-muted-foreground">
					<T>{i18n.OD_PICKED_UP_TEXT()}</T>
				</p>
				<div className="flex w-full flex-col gap-3 pt-4">
					<Button asChild size="lg" className="w-full">
						<Link to="/one-delivery/bundle/$bundleId" params={{ bundleId }}>
							{i18n.ONE_DELIVERY_TITLE()}
						</Link>
					</Button>
					<Button asChild size="lg" variant="outline" className="w-full">
						<Link to="/one-delivery">
							<T>{i18n.OD_BACK_TO_SHIPMENTS()}</T>
						</Link>
					</Button>
				</div>
			</main>
		</PageContainer>
	);
}
